module.exports = __webpack_public_path__ + "static/media/audiomack.2b4eb4af.svg";